<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      types: [],
      typesLoading: true,

      choose: {
        modal: false,
        loading: false,
        id: "",
        name: "",
        description: "",
        value: "",
        quantity: 1,
      },
    };
  },
  computed: {
    chooseTotal() {
      const qty = parseInt(this.choose.quantity) || 1;
      const val = parseFloat(this.choose.value) || 0;
      return qty * val;
    },
  },
  methods: {
    getTypes() {
      this.typesLoading = true;
      this.types = [];

      api
        .get("consultas/types")
        .then((response) => {
          if (response.data.status == "success" && Array.isArray(response.data.list)) {
            this.types = response.data.list;
          } else {
            this.types = [];
          }
        })
        .catch(() => {
          this.types = [];
        })
        .finally(() => {
          this.typesLoading = false;
        });
    },
    showChoose(type) {
      this.choose.modal = false;
      this.choose.id = type.id;
      this.choose.name = type.name;
      this.choose.description = type.description;
      this.choose.value = type.value;
      this.choose.quantity = 1;
      this.choose.modal = true;
    },
    confirmBuy() {
      if (!this.choose.id || this.choose.quantity < 1) return;

      this.choose.loading = true;

      api
        .post("consultas/orders", {
          id: this.choose.id,
          quantity: this.choose.quantity,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.choose.modal = false;
            this.$router.push("/consultas/pedidos/" + response.data.order.id);
          } else {
            this.choose.modal = false;
          }
        })
        .catch(() => {
          this.choose.modal = false;
        })
        .finally(() => {
          this.choose.loading = false;
        });
    },
  },
  mounted() {
    this.getTypes();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/consultas">Consultas</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Comprar</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Comprar</h3>
        <p></p>
      </div>
    </div>

    <div v-if="typesLoading" class="card">
      <div class="card-body">
        <div class="consulta-buy-skeleton table-responsive" aria-hidden="true">
          <table class="table table-hover mb-0">
            <thead class="thead-light">
              <tr>
                <th>
                  <div class="cbs-sk-line cbs-sk-w-40" style="height: 12px"></div>
                </th>
                <th>
                  <div class="cbs-sk-line cbs-sk-w-50" style="height: 12px"></div>
                </th>
                <th style="width: 100px">
                  <div class="cbs-sk-line cbs-sk-w-55" style="height: 12px"></div>
                </th>
                <th class="text-right" style="width: 88px">
                  <div class="cbs-sk-line cbs-sk-w-50 ml-auto" style="height: 12px"></div>
                </th>
                <th class="text-right" style="width: 110px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 5" :key="'buy-sk-' + n">
                <td class="align-middle">
                  <div class="cbs-sk-line cbs-sk-w-65" style="height: 14px"></div>
                </td>
                <td class="align-middle">
                  <div class="cbs-sk-line cbs-sk-w-90" style="height: 12px"></div>
                  <div class="cbs-sk-line cbs-sk-w-70 mt-1" style="height: 10px"></div>
                </td>
                <td class="align-middle">
                  <div class="cbs-sk-line cbs-sk-w-60" style="height: 14px"></div>
                </td>
                <td class="align-middle text-right">
                  <div class="cbs-sk-line cbs-sk-w-35 ml-auto" style="height: 14px"></div>
                </td>
                <td class="align-middle text-right">
                  <div class="cbs-sk-pill ml-auto"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-else-if="types.length > 0">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th class="text-right">Saldo</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in types" :key="index">
                  <td class="align-middle font-weight-semibold">{{ row.name }}</td>
                  <td class="align-middle text-muted">{{ row.description }}</td>
                  <td class="align-middle">{{ row.value | currency }}</td>
                  <td class="align-middle text-right font-weight-semibold">{{ row.balance }}</td>
                  <td class="align-middle text-right">
                    <button class="btn btn-default btn-sm btn-rounded" @click="showChoose(row)">
                      Comprar
                      <i class="mdi mdi-arrow-right ml-1"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <p v-else class="text-muted mb-0 text-center">Nenhum tipo de consulta disponível no momento.</p>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>{{ choose.name }}</h4>
        <p class="text-muted mb-3">{{ choose.description }}</p>
        <div class="form-group">
          <label for="quantity">Quantidade</label>
          <input
            id="quantity"
            type="number"
            class="form-control"
            v-model.number="choose.quantity"
            min="1"
            @input="choose.quantity = Math.max(1, parseInt(choose.quantity) || 1)"
          />
        </div>
        <h4 class="mb-4">Total: {{ chooseTotal | currency }}</h4>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" @click="confirmBuy" :disabled="choose.loading">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" @click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped lang="scss">
/* Skeleton da lista (compra) — mesmo padrão visual da nova consulta */
.consulta-buy-skeleton .cbs-sk-line,
.consulta-buy-skeleton .cbs-sk-pill {
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: consulta-buy-skeleton-shimmer 1.4s infinite ease-in-out;
  border-radius: 4px;
}

.consulta-buy-skeleton .cbs-sk-pill {
  width: 78px;
  height: 31px;
  border-radius: 4px;
}

.consulta-buy-skeleton .cbs-sk-w-35 {
  width: 35%;
}

.consulta-buy-skeleton .cbs-sk-w-40 {
  width: 40%;
}

.consulta-buy-skeleton .cbs-sk-w-50 {
  width: 50%;
}

.consulta-buy-skeleton .cbs-sk-w-55 {
  width: 55%;
}

.consulta-buy-skeleton .cbs-sk-w-60 {
  width: 60%;
}

.consulta-buy-skeleton .cbs-sk-w-65 {
  width: 65%;
}

.consulta-buy-skeleton .cbs-sk-w-70 {
  width: 70%;
}

.consulta-buy-skeleton .cbs-sk-w-90 {
  width: 90%;
}

@keyframes consulta-buy-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

body[data-sidebar="dark"] .consulta-buy-skeleton .cbs-sk-line,
body[data-sidebar="dark"] .consulta-buy-skeleton .cbs-sk-pill {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.08) 25%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.08) 75%
  );
  background-size: 200% 100%;
}
</style>
